export const clearProjectDetailsSearchParams = (
  searchParams: URLSearchParams
) => {
  searchParams.delete('current_view');
  searchParams.delete('building');
  searchParams.delete('floor');
  searchParams.delete('scenario');
  searchParams.delete('round');
  searchParams.delete('round_building');
  searchParams.delete('round_floor');
  searchParams.delete('selected_type');
};
